import {REQUEST_ERROR, REQUEST_SUCCESS} from '../../../../middlewares/api/actions';
import {
  IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET,
  IMPORT_ATTRIBUTE_ROW_LIST_HIDE,
  IMPORT_ATTRIBUTE_ROW_LIST_SHOW
} from './actions';

const attributeFileFormRowListReducer = (
  state = {
    isVisible: false,
    csvRows: null
  },
  action
) => {
  switch (action.type) {
    case IMPORT_ATTRIBUTE_ROW_LIST_SHOW:
      return {
        ...state,
        isVisible: true
      };
    case IMPORT_ATTRIBUTE_ROW_LIST_HIDE:
      return {
        ...state,
        isVisible: false
      };
    case REQUEST_ERROR:
      switch (action.label) {
        case IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET:
          return {
            ...state,
            isVisible: false,
            csvRows: null
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case IMPORT_ATTRIBUTE_ROW_LIST_CSV_ROWS_GET:
          return {
            ...state,
            csvRows: action.response
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default attributeFileFormRowListReducer;
